import { APP_LINKS } from '@/helpers/links';
import { CTA_KEYS } from './constants';

const ROUTES = {
  [CTA_KEYS.ADD_CASH]: APP_LINKS.addFunds,
  [CTA_KEYS.GO_TO_INVESTING]: APP_LINKS.investing,
  [CTA_KEYS.VIEW_GROWTH_CALCULATOR]: APP_LINKS.calculator,
};

export function resolveCtaRoute(ctaKey) {
  return ctaKey ? ROUTES[ctaKey] ?? null : null;
}

export function resolveCtaLabel(t, ctaKey) {
  switch (ctaKey) {
    case CTA_KEYS.ADD_CASH:
      return t('containers:decision_widget.cta_add_cash');
    case CTA_KEYS.GO_TO_INVESTING:
      return t('containers:decision_widget.cta_go_to_investing');
    case CTA_KEYS.VIEW_GROWTH_CALCULATOR:
      return t('containers:decision_widget.cta_view_growth_calculator');
    default:
      return '';
  }
}